import { render, staticRenderFns } from "./administrationVisitBdmReport.vue?vue&type=template&id=ecefce0c&scoped=true&"
import script from "./administrationVisitBdmReport.vue?vue&type=script&lang=js&"
export * from "./administrationVisitBdmReport.vue?vue&type=script&lang=js&"
import style0 from "./administrationVisitBdmReport.vue?vue&type=style&index=0&id=ecefce0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecefce0c",
  null
  
)

export default component.exports